if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: "product-form",
              productVariantId: formData.get("id"),
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(response);
          this.setAddedState();
          this.bestSeller();
          //commenting this line of code since we are activating rebuy cart and disabling the default cart we
          //don't need to change the height of the cart, it is done by rebuy itself
          //this.updateCartHeight();

            if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
            });
            this.error = false;
        })

        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }
    setAddedState() {
      const submitButton = this.querySelector('[type="submit"]');
      const icon = this.querySelector('.product-form-icon__icon');

      if (!submitButton) return;

      if (!this.classList.contains('product-form-icon')) return;

      submitButton.classList.add('product-form__submit--added');
      submitButton.setAttribute('disabled', 'disabled');

      if (icon) {
        icon.classList.remove('icon-Plus-circle');
        icon.classList.add('icon-tick');
      }
    }

    bestSeller() {
      var colorSwatches = document.querySelectorAll('.thumb-product-card__js .color-swatches a');
      if( colorSwatches.length ) {
        colorSwatches.forEach((swatch) => {
          swatch.addEventListener('click', (event) => {
              const currentTarget = event.currentTarget,
                  clickedVariantId = currentTarget.getAttribute('data-variant-id'),
                  parentDiv = currentTarget.closest('.thumb-product-card__js'),
                  swatchesList = parentDiv.querySelectorAll('.swatch'),
                  varitantImages = parentDiv.querySelectorAll('.thumb-product-card-images img');

              swatchesList.forEach((item) => {
                  item.classList.remove("active");
              });

              currentTarget.parentNode.classList.add("active");
              varitantImages.forEach((image) => {
                  const imageVariantId = image.getAttribute('data-variant-id');
                  if (clickedVariantId === imageVariantId) {
                      image.classList.add('show');
                      image.classList.remove('d-none');
                  } else {
                      image.classList.add('d-none');
                  }
              })


          });
        });
      }
    }
    updateCartHeight() {

      const titleheight = document.querySelector('.c-cart-top-content').offsetHeight;
      const footerheight = document.querySelector('.c-cart-shipping__col ').offsetHeight;
      const screenHeight = window.innerHeight;
      document.querySelector('.cart-you-may-like-wrap').setAttribute('style',`height:${screenHeight - titleheight - footerheight - 32}px`);

    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
